import { render, staticRenderFns } from "./m-addSelectionChild.vue?vue&type=template&id=51820bc2&"
import script from "./m-addSelectionChild.vue?vue&type=script&lang=js&"
export * from "./m-addSelectionChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports